import { ClockCircleOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Col, Row, Skeleton, Typography, Card } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { message } from "components/Messages/Messages";
import axios from "axios";
import { Company } from "interfaces/company";
import dayjs from "dayjs";
import CompanyLogo from "../../../components/CompanyLogo/CompanyLogo";
import { Location } from "./interfaces";
import { StyledTitle } from "./style";
import EventStatus from "./EventStatus/EventStatus";

const { Paragraph } = Typography;

interface Props {
  id: number;
  title: string;
  location: number | undefined;
  time: string;
  date: string;
  company: Company;
}

const SingleEventBox: React.FC<Props> = ({ id, title, location, time, date, company }) => {
  const [eventLocation, setEventLocation] = useState<Location>();

  useEffect(() => {
    if (location) {
      axios.get<Location>(`/events/locations/${location}/`).then(response => {
        setEventLocation(response.data);
      });
    }
  }, [location]);

  const history = useHistory();
  const { currentUser } = useLoginContext();

  const openEvent = () => {
    if (!currentUser) {
      return message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    }
    if (isCompanyUser(currentUser) && company.id !== currentUser.id) {
      return message("error", "Bedrifter kan kun åpne egne arrangementer");
    }
    return history.push(`/events/${id}/`);
  };

  return (
    <>
      <Card hoverable onClick={openEvent} bodyStyle={{ padding: "0.5em", paddingLeft: "0.8em" }}>
        <Row>
          <Col span={4}>
            {company ? <CompanyLogo size="100%" companyId={company.id} src={company.logo} /> : <Skeleton.Image />}
          </Col>
          <Col
            span={17}
            style={{ paddingLeft: "1em", lineHeight: "100%", paddingTop: "0.5em", paddingBottom: "0.5em" }}
          >
            <Row>
              <EventStatus eventId={id} />
            </Row>
            <Row>
              <StyledTitle level={4}>{title}</StyledTitle>
            </Row>
            <Row>
              <Col xs={0} sm={12}>
                <EnvironmentOutlined style={{ marginRight: "0.4em" }} />
                {!location ? (
                  "Ikke bestemt"
                ) : eventLocation ? (
                  eventLocation.name
                ) : (
                  <Skeleton.Button active style={{ height: "1em" }} />
                )}
              </Col>
              <Col xs={24} sm={12}>
                <ClockCircleOutlined style={{ marginRight: "0.4em" }} />
                kl. {time}
              </Col>
            </Row>
          </Col>
          <Col span={3} style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
            <div style={{ textAlign: "center", lineHeight: "100%" }}>
              <Paragraph style={{ fontSize: "1.3em", marginBottom: "0.6em" }}>
                {dayjs(date).format("MMM").toUpperCase().slice(0, -1)}
              </Paragraph>
              <Paragraph style={{ fontSize: "2.3em", margin: "0", paddingTop: "0" }}>
                {dayjs(date).format("DD")}
              </Paragraph>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default SingleEventBox;
